export const ROLES = {
  TEACHER: "teacher",
  SUPER_ADMIN: "superadmin",
  SCHOOL_ADMIN: "schooladmin",
  SCHOOL_NETWORK_ADMIN: "schoolnetworkadmin",
};
